module.exports = __webpack_public_path__ + "img/reducedInequality.0c433188.png";